var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRadioServiceProvider = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "nonzero",
    d: "M3 0v3.656l-3 4V8c0 1.645 1.355 3 3 3v13h16v-9h2v9h6V11c1.645 0 3-1.355 3-3v-.344l-3-4V0H3zm2 2h20v1H5V2zm-.5 3h21l2.406 3.219C27.796 8.652 27.47 9 27 9c-.555 0-1-.445-1-1h-2c0 .555-.445 1-1 1-.555 0-1-.445-1-1h-2c0 .555-.445 1-1 1-.555 0-1-.445-1-1h-2c0 .555-.445 1-1 1-.555 0-1-.445-1-1h-2c0 .555-.445 1-1 1-.555 0-1-.445-1-1H8c0 .555-.445 1-1 1-.555 0-1-.445-1-1H4c0 .555-.445 1-1 1-.469 0-.797-.348-.906-.781L4.5 5zm.5 5.219c.531.48 1.234.781 2 .781s1.469-.3 2-.781c.531.48 1.234.781 2 .781s1.469-.3 2-.781c.531.48 1.234.781 2 .781s1.469-.3 2-.781c.531.48 1.234.781 2 .781s1.469-.3 2-.781c.531.48 1.234.781 2 .781s1.469-.3 2-.781V22h-2v-9h-6v9H5V10.219zM7 13v7h8v-7H7zm2 2h4v3H9v-3z",
    opacity: 1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRadioServiceProvider, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/radio_service_provider.3e1663d7.svg";
export { ForwardRef as ReactComponent };